/**
 * Where the public site (nsibi.app) is, from where THIS page is running.
 *
 * A dev server (Vite's `import.meta.env.DEV`) links to the site's dev
 * server on the same host - localhost, or this machine's LAN name for a
 * phone - so a local test never opens the live site; every production
 * build goes to nsibi.app. The site does the same the other way round
 * (`webAppOrigin`, web-site lib/site.ts).
 */
const PROD_SITE = 'https://nsibi.app';
/** The public site's dev server (`clients/apps/web-site`, `next dev -p 3001`). */
const DEV_SITE_PORT = 3001;

export function siteOrigin(): string {
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    return `${window.location.protocol}//${window.location.hostname}:${DEV_SITE_PORT}`;
  }
  return PROD_SITE;
}
